import { ContinuousCarousel } from '../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../../../../components/Container/Container';
import { GetFishingWaterNearbyWaters_fishingWater_suggestedWaters } from '../../../../interfaces/graphql';
import { SUB_LINK_IDS } from '../../helpers/fishingWaterHelpers';
import { NearbyWaterCard } from './components/NearbyWaterCard';

interface IProps {
  nearbyWaters: GetFishingWaterNearbyWaters_fishingWater_suggestedWaters[];
}

export const NearbyWatersSection = ({ nearbyWaters }: IProps) => {
  const headingText = 'Other fishing waters nearby';

  return (
    <Container
      id={SUB_LINK_IDS.NEARBY_WATERS}
      className="mb-fw scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset)"
    >
      <ContinuousCarousel
        title={headingText}
        headingVariant="sm"
        outerClass="mt-0!"
        dataTestId="nearby-waters"
        childrenClassName="w-col-3 min-w-col-3 sm:w-col-6 sm:min-w-col-6 md:w-col-3 md:min-w-col-3"
      >
        {nearbyWaters.map((water, index) => {
          const { _id } = water;
          return (
            <NearbyWaterCard
              clickEventSource="nearby-fishing-waters"
              clickEventPosition={index}
              clickEventSourceId={_id}
              key={`nearby-water-${_id}`}
              suggestedWater={water}
            />
          );
        })}
      </ContinuousCarousel>
    </Container>
  );
};
